import IcEdit from './IcEdit'

export default IcEdit
